import { Action, createFeature, createReducer, on } from "@ngrx/store";
import { createRehydrateReducer } from "@shared/utils/state_rehydration.util";
import { storeActions } from "./actions";
import { StoreDetailsState } from "@core/models/store.interface";
import { StoreDetailsDTO } from "@core/models/dto.models";

export const initialStoreState: StoreDetailsState = {
  isLoading: false,
  storeDetails: {} as StoreDetailsDTO,
};

const storeFeature = createFeature({
  name: "storeDetails",
  reducer: createRehydrateReducer<StoreDetailsState, Action>(
    "StoreDetailsState",
    createReducer(
      initialStoreState,
      on(storeActions.setStoreDetails, (state, event) => ({
        ...state,
        isLoading: true,
      })),
      on(storeActions.setStoreDetailsSuccess, (state, event) => ({
        ...state,
        isLoading: false,
        storeDetails: event.storeDetails!,
      })),
      on(storeActions.setStoreDetailsFail, (state) => ({
        ...initialStoreState,
      }))
    ),
    initialStoreState
  ),
});

export const { name: storeFeatureKey, reducer: storeReducer } = storeFeature;
